// Live GraphQL operation for the AWS AI Cost Trends reporting tab
// (consumed by AWSAICostTrendsReporting.tsx). Plain backtick template
// — see getAISpendTrends.ts header for the convention rationale.
export const GET_AI_SPEND_TRENDS_REPORT = `
  query GetAISpendTrendsReport($startDate: String!, $endDate: String!, $serviceCode: String) {
    getAISpendTrendsReport(startDate: $startDate, endDate: $endDate, serviceCode: $serviceCode) {
      rows {
        usageDate
        element4Map
        budgetName
        serviceCode
        serviceName
        accountId
        accountName
        claimed
        shared
        totalCost
        allocationAnchorType
        tokens
      }
      summary {
        totalClaimed
        totalShared
        totalCost
        serviceBreakdown {
          serviceCode
          serviceName
          totalCost
          totalClaimed
          totalShared
        }
      }
      startDate
      endDate
    }
  }
`
